{
  "moreActions": "Meer handelingen",
  "unavailable": "Niet beschikbaar, uitvouwen voor meer informatie"
}
